module.exports = __webpack_public_path__ + "img/record.572c3653.webp";